import type {
  StageDto,
  StageCreateDto,
  StageUpdateDto,
  StageReorderDto,
} from '@camper-diary/shared';
import { api } from './client';

export type Stage = StageDto;

export function listStages(tripId: string) {
  return api<Stage[]>(`/trips/${encodeURIComponent(tripId)}/stages`);
}

export function createStage(tripId: string, input: StageCreateDto) {
  return api<Stage>(`/trips/${encodeURIComponent(tripId)}/stages`, {
    method: 'POST',
    body: input,
  });
}

export function updateStage(tripId: string, id: string, input: StageUpdateDto) {
  return api<Stage>(
    `/trips/${encodeURIComponent(tripId)}/stages/${encodeURIComponent(id)}`,
    { method: 'PATCH', body: input },
  );
}

export function deleteStage(tripId: string, id: string) {
  return api<null>(
    `/trips/${encodeURIComponent(tripId)}/stages/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
  );
}

export function reorderStages(tripId: string, ids: string[]) {
  const body: StageReorderDto = { ids };
  return api<Stage[]>(`/trips/${encodeURIComponent(tripId)}/stages/reorder`, {
    method: 'POST',
    body,
  });
}
